export default __webpack_public_path__ + "static/media/Topography.dd11fb30.png";